import {Run} from './run'

angular.module('app')
  .run(['$location', '$sce', '$route', '$rootScope', '$timeout', '$modal', 'AuthService', 'UserService', 'LikeService', 'BannerService', 'GiftService', 'socket', 'amMoment', 'ngMeta',
  ($location, $sce, $route, $rootScope, $timeout, $modal, AuthService, UserService, LikeService, BannerService, GiftService, socket, amMoment, ngMeta) => new Run(
   $location, $sce, $route, $rootScope, $timeout, $modal, AuthService, UserService, LikeService, BannerService, GiftService, socket, amMoment, ngMeta)]);
